import { useMemo, useCallback, useState } from 'react';

const useNodeManager = () => {
  const [nodes, setNodes] = useState({});

  const register = useCallback((key, node) => {
    setNodes((n) => ({ ...n, [key]: node }));
  }, []);

  const unregister = useCallback((key) => {
    setNodes((n) => {
      const { [key]: omitted, ...rest } = n; // eslint-disable-line
      return rest;
    });
  }, []);

  return useMemo(() => {
    return {
      nodes,
      register,
      unregister,
    };
  }, [nodes, register, unregister]);
};

export default useNodeManager;
